import Constants from './constants';

export const flags = {
    showDriversLicenseCopy: ['US', 'CA', 'MX'],
    showGenericDriversLicenseCopy: ['AT', 'BE', 'CH', 'CZ', 'DK', 'DE', 'EU', 'GR', 'ES', 'FI', 'FR', 'HR', 'IE', 'IL', 'IS', 'IT', 'LU', 'NL', 'NO', 'PL', 'PT', 'SI', 'SE'],
    showMinimumAgeToDrive: ['GB'],
    availableModels: {
        default: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3],
        US: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3, Constants().MODEL_Y],
        CA: [Constants().MODEL_S, Constants().MODEL_X, Constants().MODEL_3, Constants().MODEL_Y],
        CN: [Constants().MODEL_3, Constants().MODEL_Y, Constants().MODEL_X, Constants().MODEL_S],
        BE: [Constants().MODEL_3],
        CZ: [Constants().MODEL_3],
        DK: [Constants().MODEL_3],
        DE: [Constants().MODEL_3],
        GR: [Constants().MODEL_3],
        ES: [Constants().MODEL_3],
        FR: [Constants().MODEL_3],
        HR: [Constants().MODEL_3],
        GB: [Constants().MODEL_3],
        IE: [Constants().MODEL_3],
        IS: [Constants().MODEL_3],
        IT: [Constants().MODEL_3],
        LU: [Constants().MODEL_3],
        NL: [Constants().MODEL_3],
        NO: [Constants().MODEL_3],
        AT: [Constants().MODEL_3],
        PL: [Constants().MODEL_3],
        PT: [Constants().MODEL_3],
        SI: [Constants().MODEL_3],
        CH: [Constants().MODEL_3],
        SE: [Constants().MODEL_3],
        FI: [Constants().MODEL_3],
        EU: [Constants().MODEL_3],
    }
};

/**
 * Process an object like 'flags' and determine which keys render true/false.
 * Currently we only need per-market flags, but this can be extended upon.
 *
 * @param flags
 * @param market
 * @returns {{}}
 */
export const processFlags = (flags, market) => {
    return Object.keys(flags).reduce((processedFlags, flagKey) => {
        let flagValue = false;
        const flagContents = flags[flagKey];

        if (Array.isArray(flagContents)) {
            flagValue = flagContents.indexOf(market) >= 0;
        } else if (flagContents instanceof Object) {
            flagValue = flagContents[market] || flagContents.default || null;
        }

        return {
            ...processedFlags,
            [flagKey]: flagValue,
        }
    }, {});
};

